import { useNavigate } from "react-router-dom";

import { useUser } from "@/context/user-context";
import { PromptVersion } from "@/types/apiGetters";

const useNavigateToPromptVersion = (promptVersion?: PromptVersion) => {
  const user = useUser();
  const navigate = useNavigate();

  const workspaceId = user?.activeWorkspaceId ?? 0;
  return () =>
    navigate(
      `/workspace/${workspaceId}/prompt/${promptVersion?.prompt_id}/version/${promptVersion?.number}`,
    );
};

export default useNavigateToPromptVersion;
